import { debugApi, error } from '@/log';
import { Get, Post } from "@/services/Server";
import URL from "@/services/urls";
import { AddBasicTicketEventRequest, BasicTicketEvent, CallbackRequest, ChatWidgetActionRequest, SendRequest } from '@/TickApi';
import * as LOG from "@/log";

export async function sendMessage(request: SendRequest): Promise<ChatWidgetActionRequest> {
  try {
    const response = await Post<ChatWidgetActionRequest>(URL.sendMessage, request);
    debugApi(`[Ticket:Message]send message to: ${request.to}`)
    return response.data;
  } catch (error) {
    // TODO: services should throw errors
    LOG.error('Error while sending messages', error);
    throw new error();
  }

}

export async function sendCallbackRequest(request: CallbackRequest, to: string, chatWidgetId: string) {
  debugApi(`[Ticket:CallbackRequest]send request to: ${to}`)
  await Post<unknown>(URL.sendCallbackRequest + `/${to}/${chatWidgetId}`, request).catch((err) => {
    LOG.error("error while sending callback request", err);
  });
}


export async function getMessages(ticketId: string, to: string, chatWidgetId: string, fromTicks: number): Promise<ChatWidgetActionRequest[]> {
  try {
    const response = await Get<ChatWidgetActionRequest[]>(URL.getMessages + `/${ticketId}/${to}/${chatWidgetId}/${fromTicks}`)
    debugApi(`[Ticket:FETCH]get messages`);
    return response.data;
  } catch (error) {
    // TODO: services should throw errors
    LOG.error('Error while fetching messages', error);
    throw new error();
  }

}


export async function sendBasicEvent(request: AddBasicTicketEventRequest): Promise<any> {

  try {
    const response = await Post<any>(URL.sendBasicTicketEvent, request);
    debugApi(`[Ticket:Message]send ticket event: ${request.to}`)
    return response.data;
  } catch (error) {
    // TODO: services should throw errors
    LOG.error('Error while sending basic ticket event', error);
    //throw new error();
  }

}
